// src/pages/Languages.js
import React from "react";
import { NavLink } from "react-router-dom";

const Languages = () => (
  <>
    {/* Breadcrumb */}
    <div
      className="optech-breadcrumb"
      style={{ backgroundImage: "url(/assets/images/breadcrumb/breadcrumb.png)" }}
    >
      <div className="container">
        <h1 className="post__title">Languages</h1>
        <nav className="breadcrumbs">
          <ul>
            <li>
              <NavLink to="/services">AI Service</NavLink>
            </li>
            <li aria-current="page">Languages</li>
          </ul>
        </nav>
        <p className="text-white pt-5">
          Cross-cultural communication is central to global business success. At R A Inc, our language capabilities embrace Indic, South Asian, and European languages, ensuring that critical documentation and creative content maintain the right tone and clarity for diverse audiences.
        </p>
      </div>
    </div>

    {/* Service Details */}
    <div className="section optech-section-padding">
      <div className="container">
        <div className="row">
          {/* Main content */}
          <div className="col-lg-8">
            <div className="optech-service-details-wrap">
              <img
                data-aos="fade-up"
                data-aos-duration="800"
                src="/assets/images/service/languages.jpg"
                alt="Languages Service"
              />

              <div className="optech-service-details-item">
                <h3>Overview</h3>
                <p>
                  Language operates as more than a translation of words; it provides cultural subtext and local resonance. For instance, a medical handbook translated for a South Asian audience may necessitate particular phrasing or references to ensure people understand the text clearly. Similarly, marketing materials directed at European consumers should mirror cultural norms that feel genuine, not forced. Our expertise helps clients adapt content so it speaks to readers in a way that truly resonates.
                </p>
              </div>

              <div className="optech-service-details-item">
                <h3>Key Focus Areas</h3>
                <div className="optech-icon-list">
                  <ul>
                    <li>
                      <i className="ri-check-line" /> <strong>Accuracy:</strong> We consistently verify meanings and references to capture subtle linguistic nuances.
                    </li>
                    <li>
                      <i className="ri-check-line" /> <strong>Cultural Adaptation:</strong> Adjusting references, idioms, and style based on the target region’s norms.
                    </li>
                    <li>
                      <i className="ri-check-line" /> <strong>Quality Assurance:</strong> Each translation undergoes multiple review stages for grammar, clarity, and context.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="optech-service-details-item">
                <h3>Language Specialization</h3>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Region</th>
                      <th>Typical Languages</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Indic</td>
                      <td>Hindi, Bengali, Punjabi, Marathi, etc.</td>
                    </tr>
                    <tr>
                      <td>South Asian</td>
                      <td>Nepali, Sinhala, Urdu, etc.</td>
                    </tr>
                    <tr>
                      <td>European</td>
                      <td>Spanish, French, German, Italian, etc.</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="optech-service-details-item">
                <h3>Highlights</h3>
                <ul className="list-unstyled">
                  <li>
                    <i className="ri-check-line" /> Native-speaking translators ensure a deep understanding of local contexts.
                  </li>
                  <li>
                    <i className="ri-check-line" /> We manage both specialized (technical or legal) and general (marketing or narrative) content.
                  </li>
                  <li>
                    <i className="ri-check-line" /> Timely turnarounds for pressing business or legal deadlines.
                  </li>
                </ul>
              </div>

              <div className="optech-service-details-item">
                <h3>Main Points</h3>
                <ul className="list-unstyled">
                  <li>
                    <i className="ri-check-line" /> <strong>Precision:</strong> Maintaining linguistic exactness is key to authentic communication.
                  </li>
                  <li>
                    <i className="ri-check-line" /> <strong>Cultural Fit:</strong> Nuanced knowledge of local customs can enhance brand acceptance.
                  </li>
                  <li>
                    <i className="ri-check-line" /> <strong>Efficiency:</strong> Our structured workflows streamline even large-scale language projects.
                  </li>
                </ul>
              </div>

              <div className="optech-service-details-item">
                <h3>Conclusion</h3>
                <p>
                  Connecting with global markets depends on refined, context-aware translations. By tapping into R A Inc’s language expertise, your enterprise can confidently address audiences in Indic, South Asian, and European regions, helping to reinforce trust and credibility wherever you do business.
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="col-lg-4">
            <div className="optech-service-sidebar">
              <div className="optech-service-menu">
                <ul>
                  <li>
                    <NavLink to="/multimedia-and-dtp-services">
                    Multimedia & DTP Services <i className="ri-arrow-right-up-line" />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/audio-and-video-transcription">
                    Audio & Video Transcription <i className="ri-arrow-right-up-line" />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/subtitling">
                    Subtitling <i className="ri-arrow-right-up-line" />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/desktop-publishing-services">
                    Desktop Publishing Services <i className="ri-arrow-right-up-line" />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/multilingual-desktop-publishing">
                    Multilingual Desktop Publishing <i className="ri-arrow-right-up-line" />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/multimedia-and-dtp-tools">
                    Multimedia & DTP Tools <i className="ri-arrow-right-up-line" />
                    </NavLink>
                  </li>
                </ul>
              </div>

              <div
                className="optech-service-contact"
                data-aos="fade-up"
                data-aos-duration="800"
                style={{ backgroundImage: "url(/assets/images/service/bg.png)" }}
              >
                <div className="optech-service-contact-icon">
                  <img src="/assets/images/service/icon.svg" alt="Contact icon" />
                </div>
                <h3>Need Multilingual Support?</h3>
                <p>
                  Our language specialists help your brand resonate across regional markets with clarity and confidence.
                </p>
                <NavLink
                  className="optech-default-btn"
                  data-text="Get in Touch"
                  to="/contact-us"
                >
                  <span className="btn-wraper">Get in Touch</span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom CTA */}
    <div
      className="section bg-cover optech-section-padding"
      style={{ backgroundImage: "url(/assets/images/cta/cta-bg2.png)" }}
    >
      <div className="container">
        <div className="optech-cta-wrap">
          <div className="optech-cta-content center">
            <h2>Let's Translate Your Vision Into Every Language</h2>
            <p>
              Whether you're expanding your business internationally or need multilingual content for local markets, we provide solutions tailored to your goals, audience, and tone.
            </p>
            <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
              <NavLink
                className="optech-default-btn"
                data-text="Let’s Start a Project"
                to="/contact-us"
              >
                <span className="btn-wraper">Let’s Start a Project</span>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Languages;